<template>
  <div class="min-h-full flex items-center justify-center mt-12">
    <div class="container-padded w-2/5 space-y-8 shadow-md sm:p-12">
      <h2 class="text-center mb4">
        Go Premium
      </h2>
      <ProFeatures :user="this.user" />
      <div class="text-center">
            <form @submit.prevent="checkout" class="space-y-6">
                <button type="submit"
                        class="primary-btn mt-14 px-12">
                    Go Premium
                </button>
            </form>
      </div>
    </div>
  </div>

</template>
<script>
import ProFeatures from './ProFeatures.vue';

export default {
  props:["user"],
  methods: {
      checkout() {
//          axios.get( '/api/user/checkout-premium')
//              .then((response) => {
//                  console.log( response);
            let redirect = '/api/user/checkout-premium';
                // '/storefront/' + this.user.username;
                  window.location.href = redirect;
      }
  },
  components: {
      ProFeatures
  }
};
</script>

<style scoped>
.animation-in {
  transform-origin: left;
  animation: in 0.6s ease-in-out;
}
.animation-out {
  transform-origin: bottom left;
  animation: out 0.6s ease-in-out;
}
</style>
